import { mvpApi } from "../../services/api";

/** 24-char hex Mongo ObjectId — required for DELETE /documents/:session/:id */
export function resolveMongoDocumentIdForDelete(doc: {
  documentId?: string | null;
  id?: string | null;
} | undefined | null): string | null {
  const a = String(doc?.documentId ?? "").trim();
  if (/^[a-fA-F0-9]{24}$/.test(a)) return a;
  const b = String(doc?.id ?? "").trim();
  if (/^[a-fA-F0-9]{24}$/.test(b)) return b;
  return null;
}

/**
 * Hard-delete server-side stored file when possible; no-op when `mongoDocumentId` is null.
 */
export async function deleteSessionUploadedFileIfApplicable(opts: {
  ensureCaseSession: () => Promise<string | null>;
  caseSessionId: string | null | undefined;
  mongoDocumentId: string | null;
}): Promise<{ ok: true } | { ok: false; message: string }> {
  const mid = opts.mongoDocumentId;
  if (!mid) return { ok: true };
  try {
    const sid = opts.caseSessionId ?? (await opts.ensureCaseSession());
    if (!sid) return { ok: false, message: "No session." };
    await mvpApi.deleteSessionDocument(sid, mid);
    return { ok: true };
  } catch (err: unknown) {
    const detail = (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail;
    return {
      ok: false,
      message: typeof detail === "string" ? detail : "Could not delete the file. Please try again.",
    };
  }
}
